import { render } from "./ProposalSeller.vue?vue&type=template&id=f5030814&scoped=true"
import script from "./ProposalSeller.vue?vue&type=script&lang=js"
export * from "./ProposalSeller.vue?vue&type=script&lang=js"

import "@/assets/css/components/Mypage/mypage_matching.css?vue&type=style&index=0&id=f5030814&scoped=true&lang=css"
import "@/assets/css/components/commonPopup_v2.css?vue&type=style&index=1&id=f5030814&scoped=true&lang=css"

import exportComponent from "C:\\DEVER\\meta-buysell.vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5030814"]])

export default __exports__